import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import Vant from 'vant';
// import 'vant/lib/index.css';
import store from "./store";
import "@/utils/derective";
import qs from "qs";
import animated from "animate.css";
import { setRem,debounce } from "@/utils";
import { Menu ,Icon,Carousel } from 'ant-design-vue';
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import { Toast } from 'vant';
require('@/plugins/vant')
Vue.prototype.$video = Video
Vue.use(preview).use(animated)
Vue.use(Menu).use(Icon).use(Carousel).use(Toast)
Vue.prototype.$qs = qs;
Vue.config.productionTip = false;

function setIsMobile(){
  var offsetWid = document.documentElement.clientWidth;
  
  if (offsetWid <= 1024) {
    setRem(350)
    store().commit('home/SET_isMobile',true)
    
  } else{
    store().commit('home/SET_isMobile',false)
  }
}
setIsMobile()
// debounce:防抖
window.onresize = debounce(setIsMobile,200)

window.picHttp = "https://guoguoyunyu.com/market/pic/";
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
